import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyBanner from "@/components/StickyBanner";
import WhatsappFab from "@/components/WhatsappFab";
import HomePage from "@/pages/HomePage";
import BoutiquePage from "@/pages/BoutiquePage";
import ProductPage from "@/pages/ProductPage";
import AboutPage from "@/pages/AboutPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import AdminPage from "@/pages/AdminPage";
import BootcampPage from "@/pages/BootcampPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import CGVPage from "@/pages/CGVPage";
import PolitiqueCookiesPage from "@/pages/PolitiqueCookiesPage";
import CookieBanner from "@/components/CookieBanner";
import ScrollToHash from "@/components/ScrollToHash";
import PromoStickyBar from "@/components/PromoStickyBar";
import { BOUTIQUE_ENABLED } from "@/lib/features";
import { Navigate } from "react-router-dom";
import "@/App.css";

function App() {
  return (
    <div className="min-h-screen bg-pearl text-ink">
      <BrowserRouter>
        <ScrollToHash />
        <PromoStickyBar />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          {BOUTIQUE_ENABLED ? (
            <>
              <Route path="/boutique" element={<BoutiquePage />} />
              <Route path="/produit/:slug" element={<ProductPage />} />
              <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            </>
          ) : (
            <>
              <Route path="/boutique" element={<Navigate to="/" replace />} />
              <Route path="/produit/:slug" element={<Navigate to="/" replace />} />
              <Route path="/checkout/success" element={<Navigate to="/" replace />} />
            </>
          )}
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/bootcamp" element={<BootcampPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/cgv" element={<CGVPage />} />
          <Route path="/politique-cookies" element={<PolitiqueCookiesPage />} />
        </Routes>
        <Footer />
        {BOUTIQUE_ENABLED && <StickyBanner />}
        <WhatsappFab />
        <CookieBanner />
        <Toaster position="bottom-center" theme="light" />
      </BrowserRouter>
    </div>
  );
}

export default App;
